import React from "react";
import FlatButton from "material-ui/FlatButton";
import PropTypes from "prop-types";
import Button from "@techsoftware/happay-widgets/Button";
export default class PrimaryButton extends React.Component {
    constructor(props) {
        super(props);
    }

    handleKeyDowm = e => {
        if (e.keyCode === 13) {
            this.props.onClick(e);
        }
    };

    render() {
        let buttonStyle = {
            color: "#ffffff",
            height: "auto",
            lineHeight: 1,
            padding: "10px 16px",
            fontFamily: "Roboto-Medium",
            fontSize: "12px",
            fontWeight: 500,
            borderRadius: "3px",
            margin: "0px 5px",
            border: "solid 1px #5e89c7",
            pointerEvents: this.props.disabled ? "none" : "auto"
            //boxShadow: '0 2px 4px 0 rgba(0, 0, 0, 0.2)'
        };
        //console.log('disabled ',this.props)
        if (this.props.isWidgetComp) {
            return (
                <Button
                    onClick={this.props.onClick}
                    type="button"
                    text={this.props.label}
                    startIcon={this.props.startIcon}
                    variant="primary"
                    size="normal"
                    className={this.props.className}
                    {...this.props}
                />
            );
        }
        return (
            <FlatButton
                {...this.props}
                primary={true}
                backgroundColor={"#5e89c6"}
                //hoverColor={'#4a74b1'}
                className="primaryButton"
                style={Object.assign({}, buttonStyle, this.props.style)}
                labelStyle={Object.assign(
                    {},
                    { fontSize: "12px", padding: 0, verticalAlign: "inherit" },
                    this.props.labelStyle
                )}
                onKeyDown={this.handleKeyDowm}
            />
        );
    }
}

PrimaryButton.propTypes = {
    onClick: PropTypes.func
};

PrimaryButton.defaultProps = {
    onClick: () => {}
};
